import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Layer 2" }, [
      _createElementVNode("path", { d: "M34.351 494.008a17.025 17.025 0 0 1-17.025-17.025V22.985a17.025 17.025 0 0 1 34.05 0v453.998a17.025 17.025 0 0 1-17.025 17.025M449.759 492.6a62.31 62.31 0 0 1-64.082-3.11L104.198 301.922a62.402 62.402 0 0 1 0-103.874l281.434-187.57a62.425 62.425 0 0 1 97.042 51.938v375.138a62.38 62.38 0 0 1-32.915 55.047m-1.135-430.185a27.97 27.97 0 0 0-14.982-24.97 28.44 28.44 0 0 0-13.393-3.473 28.1 28.1 0 0 0-15.686 4.835l-281.478 187.57a28.352 28.352 0 0 0 0 47.215l281.433 187.501a28.375 28.375 0 0 0 44.106-23.608Z" })
    ], -1)
  ])))
}
export default { render: render }